import { Layout, Menu } from "antd";
import SiteLogo from "../../../../assets/images/site-logo.png";
import { ReactComponent as CollapseIcon } from "../../../../assets/images/sidebar-collapse-icon.svg";
import { ReactComponent as DashboardIcon } from "../../../../assets/images/menu-icon/dashboard.svg";
import { ReactComponent as CandidateIcon } from "../../../../assets/images/menu-icon/candidate.svg";
import { ReactComponent as ReportIcon } from "../../../../assets/images/menu-icon/reports.svg";
import SVGIcon from "../../../../utils/SVGIcon";
import { CONSTANT } from "../../../../config/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsRestricted } from "../../../../features/auth/authSlice";

const SidebarComponent = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { moduleRightsData } = useSelector((state) => state.auth);

  const [menu, setMenu] = useState();

  const items = useMemo(
    () => [
      {
        key: CONSTANT.ROUTE.DASHBOARD,
        icon: <DashboardIcon />,
        label: "Dashboard",
        code: CONSTANT.MODULE_CODE.DASHBOARD,
      },
      {
        key: CONSTANT.ROUTE.CANDIDATE_LIST,
        icon: <CandidateIcon />,
        label: "Candidates",
        code: CONSTANT.MODULE_CODE.CANDIDATE,
      },
      {
        key: "masterMenu",
        label: "Administration",
        icon: <ReportIcon />,
        children: [
          {
            key: CONSTANT.ROUTE.USER,
            label: "User",
            code: CONSTANT.MODULE_CODE.USER,
          },
          {
            key: CONSTANT.ROUTE.MESSAGE,
            label: "Message",
            code: CONSTANT.MODULE_CODE.MESSAGE,
          },
          {
            key: CONSTANT.ROUTE.FRAMEWORK,
            label: "Framework",
            code: CONSTANT.MODULE_CODE.FRAMEWORK,
          },
          {
            key: CONSTANT.ROUTE.ROLE,
            label: "Role",
            code: CONSTANT.MODULE_CODE.ROLE,
          },
          {
            key: CONSTANT.ROUTE.DOCUMENT,
            label: "Document",
            code: CONSTANT.MODULE_CODE.DOCUMENT,
          },
          {
            key: CONSTANT.ROUTE.FORM,
            label: "Form",
            code: CONSTANT.MODULE_CODE.FORM,
          },
        ],
      },
      // {
      //   key: "sub2",
      //   label: "Navigation Two",
      //   icon: <CandidateIcon />,
      //   children: [
      //     {
      //       key: "9",
      //       label: "Option 9",
      //     },
      //     {
      //       key: "10",
      //       label: "Option 10",
      //     },
      //     {
      //       key: "sub3",
      //       label: "Submenu",
      //       children: [
      //         {
      //           key: "11",
      //           label: "Option 11",
      //         },
      //         {
      //           key: "12",
      //           label: "Option 12",
      //         },
      //       ],
      //     },
      //   ],
      // },
    ],
    []
  );

  const filterMenuByPermission = useCallback((menuItems, permissions) => {
    return menuItems
      .map((item) => {
        if (item.children) {
          const filteredChildren = filterMenuByPermission(
            item.children,
            permissions
          );
          return filteredChildren.length > 0
            ? { ...item, children: filteredChildren }
            : null;
        }

        const hasViewPermission =
          permissions.hasOwnProperty(item.code) &&
          permissions[item.code]?.includes(CONSTANT.MODULE_PERMISSION.VIEW);
        return hasViewPermission ? item : null;
      })
      .filter(Boolean); // Remove null entries
  }, []);

  const handleMenuClick = (item) => {
    dispatch(setIsRestricted(false));
    navigate(item.key);
  };

  useEffect(() => {
    if (moduleRightsData) {
      const mainMenu = filterMenuByPermission(items, moduleRightsData);
      setMenu(mainMenu);
    }
  }, [moduleRightsData, items, filterMenuByPermission]);

  return (
    <>
      <Layout.Sider
        collapsed={collapsed}
        width={250}
        collapsedWidth={0}
        // defaultCollapsed={false}
        className="main__page__appsidebar"
      >
        <div className="sidebarLogoSec">
          <span onClick={() => setCollapsed(!collapsed)}>
            <CollapseIcon />
          </span>
          <img src={SiteLogo} className="logo" alt="Site Logo" />
        </div>
        <Menu
          mode="inline"
          defaultSelectedKeys={[location.pathname]}
          expandIcon={<SVGIcon icon="down_arrow" />}
          onClick={(item) => handleMenuClick(item)}
          items={menu}
        />
      </Layout.Sider>
    </>
  );
};

export default SidebarComponent;
